/**
 * WhatsApp Message Sender Utility
 * Generates WhatsApp messages with laptop details and opens WhatsApp Web or App
 */

export const sendLaptopDetailsViaWhatsApp = (laptop) => {
  if (!laptop) return;

  // Format the laptop details for the message
  const details = [
    `*🔍 LAPTOP INQUIRY*`,
    ``,
    `*Product Details:*`,
    `Brand: ${laptop.brand || 'N/A'}`,
    `Model: ${laptop.name || 'N/A'}`,
    ``,
    `*Specifications:*`,
    ...(laptop.cpu ? [`CPU: ${laptop.cpu}`] : []),
    ...(laptop.ram ? [`RAM: ${laptop.ram}`] : []),
    ...(laptop.storage ? [`Storage: ${laptop.storage}`] : []),
    ...(laptop.display ? [`Display: ${laptop.display}`] : []),
    ``,
    `*Pricing:*`,
    `Price: ${laptop.price || 'N/A'}`,
    ...(laptop.originalPrice ? [`Original Price: ${laptop.originalPrice}`] : []),
    ``,
    `*Condition:*`,
    `${laptop.condition || 'New'}`,
    ``,
    `I am interested in this laptop. Please provide more information.`
  ].join('%0A'); // %0A is the URL-encoded newline character

  // WhatsApp Business number (you can hardcode the number or pass it as parameter)
  // Format: country code + number (e.g., 966xxxxxxx for Saudi Arabia)
  const phoneNumber = '966xxxxxxx'; // Replace with actual WhatsApp Business number

  // Create WhatsApp link
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${details}`;

  // Open WhatsApp in new window/tab
  window.open(whatsappLink, '_blank');
};

/**
 * Alternative: Send WhatsApp message with custom phone number
 */
export const sendLaptopDetailsViaWhatsAppCustom = (laptop, phoneNumber) => {
  if (!laptop) return;

  const details = [
    `*🔍 LAPTOP INQUIRY*`,
    ``,
    `*Product Details:*`,
    `Brand: ${laptop.brand || 'N/A'}`,
    `Model: ${laptop.name || 'N/A'}`,
    ``,
    `*Specifications:*`,
    ...(laptop.cpu ? [`CPU: ${laptop.cpu}`] : []),
    ...(laptop.ram ? [`RAM: ${laptop.ram}`] : []),
    ...(laptop.storage ? [`Storage: ${laptop.storage}`] : []),
    ...(laptop.display ? [`Display: ${laptop.display}`] : []),
    ``,
    `*Pricing:*`,
    `Price: ${laptop.price || 'N/A'}`,
    ...(laptop.originalPrice ? [`Original Price: ${laptop.originalPrice}`] : []),
    ``,
    `*Condition:*`,
    `${laptop.condition || 'New'}`,
    ``,
    `I am interested in this laptop. Please provide more information.`
  ].join('%0A');

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${details}`;
  window.open(whatsappLink, '_blank');
};
